export default {
      id: "Icon--uncertain-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--uncertain",
      toString: function () {
        return this.url;
      }
    }